import { ActionTypesCommon } from "../constants/action-types";


export const setPage = (page)=> ({
    type: ActionTypesCommon.SET_PAGE_CONFIG,
    page: page
})